module.exports = __webpack_public_path__ + "static/media/project15.0d187b81.jpg";